import {
  AaaGameConceptData,
  IdXboxGameConceptData,
  PitchConceptData,
} from "../../../../models/forms";
import { OutputRecord } from "../../../cvs/mappers/mapResponseToClient";
import { IdXboxFormsData } from "./forms";

export type ContentValidationCrmData = {
  isStarted: Record<
    | keyof IdXboxFormsData
    | keyof IdXboxGameConceptData
    | keyof AaaGameConceptData
    | keyof PitchConceptData,
    boolean
  >;
  contentValidationService: OutputRecord | ContentValidationStatus;
};

export type PitchContentValidationCrmData = {
  isStarted: Record<keyof PitchConceptData, boolean>;
};

export enum ContentValidationStatus {
  unset = "Unset",
  processing = "Processing",
  passed = "Passed",
}
